import React, { Component, Fragment } from "react";
import { Row, Col } from 'react-bootstrap';
import { Modal } from "react-bootstrap";
import Panel from "@common/externos/components/panel/panel.component";
import autoBind from "react-autobind";
import { ddados } from "../consultarProtocolo.ddados";
import DDadosItem from '@common/components/ddados/ddados.item';
import { connect } from "@common/components/base.component";
import consultarProtocoloSelector from "../store/consultarProtocolo.selectors";
import consultarProtocoloActions from "../store/consultarProtocolo.actions";
import Form from "@common/externos/components/validation/form.validation";
import Button from '@material-ui/core/Button';

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  onHide(){
    this.props.consultarProtocoloActions.modalViewAnalise();
  }

  render() {
    const { Campos } = ddados;
    const { consultarProtocolo } = this.props.consultarProtocoloSelector;
    const { ViewAnalise } = consultarProtocolo;

    return (
      <>
        <Form
        isView={true}
        >
        {form => (
          <Fragment>
            <Panel title="Análise" expanded={true} expandedFix={true}>
              <Row>
                <Col xs={12} lg={2}>
                  <DDadosItem name="IdAnalise" {...Campos.Analise} state={ViewAnalise.DadosAnaliseHeader} isView={true} />
                </Col>
                <Col xs={12} lg={3}>
                  <DDadosItem name="IdAnaliseOrgao" {...Campos.AnaliseOrgao} state={ViewAnalise.DadosAnaliseHeader} isView={true} />
                </Col>
                <Col xs={12} lg={5}>
                  <DDadosItem name="Orgao" {...Campos.Orgao} state={ViewAnalise.DadosAnaliseHeader} isView={true} />
                </Col>
                <Col xs={12} lg={2}>
                  <DDadosItem name="Servico" {...Campos.Servico} state={ViewAnalise.DadosAnaliseHeader} isView={true} />
                </Col>
              </Row>
              <Row>
                <Col xs={12} lg={2}>
                  <DDadosItem name="DataInicio" {...Campos.DataInicio} state={ViewAnalise.DadosAnaliseHeader} isView={true} />
                </Col>
                <Col xs={12} lg={4}>
                  <DDadosItem name="StatusAnalise" {...Campos.StatusAnalise} isView={true} state={ViewAnalise.DadosAnaliseHeader} />
                </Col>
                <Col xs={12} lg={3}>
                  <DDadosItem name="DataFinal" {...Campos.DataFinal} isView={true} state={ViewAnalise.DadosAnaliseHeader} />
                </Col>
                <Col xs={12} lg={3}>
                  <DDadosItem name="NomeUsuario" {...Campos.Usuario} isView={true} state={ViewAnalise.DadosAnaliseHeader} />
                </Col>
              </Row>
            </Panel>
            <Panel title="Exigência" expanded={true} expandedFix={true}>
              <Row>
                <Col xs={12} lg={12}>
                  <DDadosItem name="Exigencia" {...Campos.Exigencia} state={ViewAnalise.DadosAnaliseExigencia} isView={true} />
                </Col>
              </Row>
              <Row>
                <Col xs={12} lg={12}>
                  <DDadosItem name="Motivo" {...Campos.Motivo} state={ViewAnalise.DadosAnaliseExigencia} isView={true} />
                </Col>
              </Row>
              <Row>
                <Col xs={12} lg={12}>
                  <DDadosItem name="DataRetorno" {...Campos.DataRetorno} state={ViewAnalise.DadosAnaliseExigencia} isView={true} />
                </Col>
              </Row>
              <Row>
                <Col xs={12} lg={12}>
                  <DDadosItem name="Retorno" {...Campos.Retorno} state={ViewAnalise.DadosAnaliseExigencia} isView={true} />
                </Col>
              </Row>
            </Panel>
            <Panel title="Documento" expanded={true} expandedFix={true}>
              <Row>
                <Col xs={12} lg={3}>
                  <DDadosItem name="NumeroDocumento" {...Campos.NumeroDocumento} state={ViewAnalise.DadosAnaliseDocumento} isView={true} />
                </Col>
                <Col xs={12} lg={6}>
                  <DDadosItem name="TipoDocumento" {...Campos.TipoDocumento} state={ViewAnalise.DadosAnaliseDocumento} isView={true} />
                </Col>
                <Col xs={12} lg={3}>
                  <DDadosItem name="DataValidadeDocumento" {...Campos.DataValidade} state={ViewAnalise.DadosAnaliseDocumento} isView={true} />
                </Col>
              </Row>
              <Row>
                <Col xs={12} lg={12}>
                  <DDadosItem name="UrlDocumento" {...Campos.UrlDocumento} state={ViewAnalise.DadosAnaliseDocumento} isView={true} />
                </Col>
              </Row>
            </Panel>
            <Panel title="Indeferir" expanded={true} expandedFix={true}>
              <Row>
                <Col xs={12} lg={12}>
                  <DDadosItem name="MotivoIndeferimento" {...Campos.MotivoIndeferimento} state={ViewAnalise.DadosAnaliseIndeferir} isView={true} />
                </Col>
              </Row>
              <Row>
                <Col xs={12} lg={12}>
                  <DDadosItem name="MotivoCancelar" {...Campos.MotivoCancelar} state={ViewAnalise.DadosAnaliseIndeferir} isView={true} />
                </Col>
              </Row>
            </Panel>
            <Panel expanded={true} expandedFix={true}>
            <Row>
              <Col xs={12} lg={12}>
                <DDadosItem name="Observacao" {...Campos.Observacao} state={ViewAnalise} isView={true} />
              </Col>
            </Row>
            <Row>
              <Col xs={12} lg={4}>
                <DDadosItem name="CpfSolicitante" {...Campos.CPFSolicitante} state={ViewAnalise} isView={true} />
              </Col>
              <Col xs={12} lg={8}>
                <DDadosItem name="NomeSolicitante" {...Campos.Solicitante} state={ViewAnalise} isView={true} />
              </Col>
            </Row>
            </Panel>
          </Fragment>
        )}
        </Form>
        <div style={{ textAlign: 'right', marginBottom: '70px' }}>
          <Button variant="outlined" color="primary" onClick={this.onHide}>
            <i className={"mr-1 fa fa-angle-double-left"} />{" "}
            {"Voltar"}
          </Button>
        </div>
      </>
    );
  }
}

export default connect({
  actions: {
    consultarProtocoloActions
  },
  selectors: {
    consultarProtocoloSelector
  }
})(Container);
